import type { WellbeingDot as Value } from '../api/types';

const CLASSES: Record<Value, string> = {
  ok: 'bg-success',
  watch: 'bg-idle',
  concern: 'bg-danger',
};

interface Props {
  /** `null` / `undefined` = no check-in on record. */
  value: Value | null | undefined;
  /** When true, the indicator is for a teacher viewing the dot only.
   *  When false, full RAW data is being shown elsewhere on the screen. */
  teacherView?: boolean;
}

export default function WellbeingIndicator({ value, teacherView = false }: Props) {
  const title = !value
    ? 'No wellbeing check-ins yet.'
    : teacherView
    ? value === 'concern'
      ? 'A counselor is supporting this student.'
      : value === 'watch'
        ? 'Wellbeing flagged for attention.'
        : 'Wellbeing OK.'
    : 'Wellbeing state (see Wellbeing tab for detail).';
  return (
    <span title={title}
          className={`inline-block h-2 w-2 flex-none rounded-full ${value ? CLASSES[value] : 'bg-line-hover'}`} />
  );
}
